import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { Col, Row, Label, Panel } from 'react-bootstrap';

import * as productActions from 'redux/modules/products';
import * as ficheActions from 'redux/modules/fiches';
import * as csvActions from 'redux/modules/csv';

import { initializeWithKey } from 'redux-form';
import { ReduxAsyncConnect, asyncConnect, reducer as reduxAsyncConnect } from 'redux-connect';
import { isLoaded as areProductsLoaded, load as loadProducts } from 'redux/modules/products';
import { isLoaded as areGroupsLoaded, load as loadGroups } from 'redux/modules/groups';

import { load as loadUsers } from 'redux/modules/users';
import { LinkContainer } from 'react-router-bootstrap';
import { ErrorAlert } from 'components';

var _ = require('underscore');
require('./geosuggest.css');


import { ProductList2 } from 'components';
import { ImportExport } from 'components'

import { translate } from 'react-i18next';

@translate(['common'])
@asyncConnect([{

  promise: ({ store: { dispatch, getState }, params }) => {
    const promises = [];
    promises.push(dispatch(loadGroups(params)));
    promises.push(dispatch(loadProducts(1, params)));
    promises.push(dispatch(ficheActions.load(0, params)));
    promises.push(dispatch(loadUsers(params)));
    return Promise.all(promises);
  }

}])
@connect(
  state => ({
    products: state.products.data,
    editing: state.products.editing,
    error: state.products.error,
    loading: state.products.loading,
    productsNb: state.products.productsNb,
    currentPage: state.products.currentPage,
    pages: state.products.pages,
    user: state.auth.user,
    smsActions: state.fiches.smsActions,
    fiches: state.fiches.data,
    users: state.users.data,


  }),
  { ...productActions, ...csvActions, initializeWithKey })

export default class Products extends Component {

  componentDidMount() {
    this.props.cancelEdit();
    this.props.dispatch(this.props.resetFormCs());
  }

  render() {
    var self = this;
    const {
      products, error,
      editing, loading,
      load, save,
      pages, productsNb,
      currentPage, clearProducts,
      SMSLoading, user, params, fiches, t
    } = this.props;

    const handleEdit = (product) => {
      const { editStart } = this.props; // eslint-disable-line no-shadow
      return () => editStart(product.id);
    };

    const handlePit = (params, product, fields, remove) => {
      self.props.dispatch(productActions.handlePit(params, product, fields, remove)).then(() => {
        self.props.load(parseInt(0), this.props.params);
      })
    };


    const exportProducts = (params) => {
      self.props.dispatch(productActions.exportProducts(self.props.params)).then(() => {})
    };


    const handleDelete = (sid, pid, pitId) => {
      const { deleteProduct } = this.props; // eslint-disable-line no-shadow
      return () => {
        deleteProduct(sid, pid, pitId, this.props.params).then(() => self.props.load(parseInt(0), this.props.params));
      }
    };

    const handleLoad = (page) => {
      const { load } = this.props; // eslint-disable-line no-shadow
      return () => load(parseInt(page), this.props.params);
    };

    const handleSendSMS = (product) => {
      const { sendSMS } = this.props; // eslint-disable-line no-shadow
      return () => sendSMS(product, this.props.params);
    };

    let refreshClassName = 'fa fa-refresh';
    if (loading) {
      refreshClassName = 'fa fa-refresh fa-spin';
    }
    const styles = require('./Products.scss');

    var cid = this.props.params.id
    var addUrl = cid != undefined ? '/admin/products/' + cid + '/create' : '/client/addProduct';

    if (user.super_user == 1) {
      addUrl = '/user/addProduct'
    }


    return (
      <div className={styles.products + ' container'}>
        <Row>
          <Col xs={12} md={12} >
            <div>
              <h1>{t("main.the_sheets")}&nbsp;
                <button className={styles.refreshBtn + ' btn btn-success btn-sm'} onClick={handleLoad(currentPage)}>
                  <i className={refreshClassName} /> {' '}
                </button>
                &nbsp;

                {(user.role != 'user' || user.super_user == 1) && <span>
                  <LinkContainer to={addUrl}>
                    <button className={styles.refreshBtn + ' btn btn-primary btn-sm'}>
                      <i className='fa fa-wpforms' /> {' '} {t("main.create_sheet")}
                  </button>
                  </LinkContainer>

                  &nbsp;

                  <ImportExport
                    products={this.props.products}
                    fiches={this.props.fiches}
                    cid={this.props.params.id}
                    dispatch={this.props.dispatch}
                    params={this.props.params}
                    exportCSV={this.props.exportCSV}
                  /></span>
                }


              </h1>

              <br />

              {error &&
                <ErrorAlert errorMessage={error} buttonText={t("dashboardView.reload_page")} callback={() => this.props.load(currentPage, this.props.params)} />
              }
            </div>

          </Col>

        </Row>

        <Helmet title="Fiches" />
        {products.length > 0 &&

          <ProductList2
            handlePit={handlePit} products={products}
            user={user} params={params} handleEdit={handleEdit}
            handleDelete={handleDelete}
            smsActions={this.props.smsActions}
            fiches={this.props.fiches}
          />

        }

      </div >
    );
  }
}